/**
 * push.ts — Web Push subscription endpoints (PR-15 split of api/client.ts).
 *
 * Three-call surface: fetch the VAPID public key (so the browser can build
 * its subscription), POST a subscription, DELETE one by endpoint. Kept as
 * its own file so the kid app's push-notifications helper has a clean
 * single-feature import target.
 *
 * 调用关系：
 *   - Merged into the unified `api` object via api/client.ts.
 *   - Consumer: frontend/src/lib/pushNotifications.ts and any settings UI
 *     that toggles notifications on/off.
 *   - Backend: backend/src/routes/push.js; VAPID keys come from worker
 *     secrets VAPID_PUBLIC_KEY / VAPID_PRIVATE_KEY.
 *
 * 关键约束：
 *   - public_key may be null when the worker is missing the secret —
 *     callers must treat that as "push disabled" rather than retry.
 */
import { call } from './_core';

export const pushApi = {
  pushPublicKey() {
    return call<{ public_key: string | null; enabled: boolean }>('/api/v1/child/push/public-key');
  },
  pushSubscribe(subscription: PushSubscriptionJSON) {
    return call<{ ok: true }>('/api/v1/child/push/subscribe', {
      method: 'POST', body: JSON.stringify({ subscription }),
    });
  },
  pushUnsubscribe(endpoint: string) {
    return call<{ ok: true }>('/api/v1/child/push/unsubscribe', {
      method: 'POST', body: JSON.stringify({ endpoint }),
    });
  },
};
